import { render, staticRenderFns } from "./connect-guide.vue?vue&type=template&id=2047d0d5&"
import script from "./connect-guide.vue?vue&type=script&lang=js&"
export * from "./connect-guide.vue?vue&type=script&lang=js&"
import style0 from "./connect-guide.vue?vue&type=style&index=0&id=2047d0d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports